import React from 'react'
import styles from './image-placeholder.module.scss'
import errorWaves from 'assets/error-waves.svg'
import circularFieldWaves from 'assets/circular-field-waves.svg'

const ImagePlaceholder = ({ failed = false }) => {
    const src = failed ? errorWaves : circularFieldWaves
    return (
        <div className={`${styles.container} ${failed ? styles.failed : ''}`}>
            <img src={src} alt="Loading..." />
        </div>
    )
}

export default ImagePlaceholder
